var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiMesssageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Leading Icon",
    clipPath: "url(#clip0_2875_2164)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.33331 8.66665L4.85629 9.71259C5.03328 10.0666 5.12177 10.2436 5.24 10.3969C5.34491 10.533 5.46692 10.6551 5.60302 10.76C5.75639 10.8782 5.93338 10.9667 6.28737 11.1437L7.33331 11.6666L6.28737 12.1896C5.93338 12.3666 5.75639 12.4551 5.60302 12.5733C5.46692 12.6782 5.34491 12.8003 5.24 12.9363C5.12177 13.0897 5.03328 13.2667 4.85629 13.6207L4.33331 14.6666L3.81034 13.6207C3.63335 13.2667 3.54485 13.0897 3.42663 12.9363C3.32172 12.8003 3.19971 12.6782 3.06361 12.5733C2.91024 12.4551 2.73324 12.3666 2.37926 12.1896L1.33331 11.6666L2.37926 11.1437C2.73324 10.9667 2.91024 10.8782 3.06361 10.76C3.19971 10.6551 3.32172 10.533 3.42663 10.3969C3.54485 10.2436 3.63335 10.0666 3.81034 9.71259L4.33331 8.66665Z",
    stroke: "#A6A9B2",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.99998 1.33331L10.7857 3.37626C10.9737 3.86508 11.0677 4.10949 11.2139 4.31507C11.3435 4.49728 11.5027 4.65648 11.6849 4.78604C11.8905 4.93222 12.1349 5.02622 12.6237 5.21423L14.6666 5.99998L12.6237 6.78573C12.1349 6.97374 11.8905 7.06774 11.6849 7.21392C11.5027 7.34348 11.3435 7.50268 11.2139 7.68489C11.0677 7.89047 10.9737 8.13488 10.7857 8.6237L9.99998 10.6666L9.21423 8.6237C9.02622 8.13488 8.93222 7.89047 8.78604 7.68489C8.65648 7.50268 8.49728 7.34348 8.31507 7.21392C8.10949 7.06774 7.86508 6.97374 7.37626 6.78573L5.33331 5.99998L7.37626 5.21423C7.86508 5.02622 8.10949 4.93222 8.31507 4.78604C8.49728 4.65648 8.65648 4.49728 8.78604 4.31507C8.93222 4.10949 9.02622 3.86508 9.21423 3.37626L9.99998 1.33331Z",
    stroke: "#A6A9B2",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2875_2164"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiMesssageIcon);
export default __webpack_public_path__ + "static/media/ai_messsage_icon.7e0f463131186a83c31a1e4fdc677265.svg";
export { ForwardRef as ReactComponent };